import script from "./PorfolioIndexesGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./PorfolioIndexesGrid.vue?vue&type=script&setup=true&lang=js"

import "./PorfolioIndexesGrid.vue?vue&type=style&index=0&id=7367e8c3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7367e8c3"]])

export default __exports__